import React from 'react'

import classes from './amplitudeLoadingScreen.module.css'

export const AmplitudeLoadingScreen = () => (
  <div className={classes.screen} role="status" aria-live="polite">
    <div className={classes.content}>
      <span className={classes.spinner} aria-hidden="true" />
      <span className={classes.label}>Loading</span>
    </div>
  </div>
)

export default AmplitudeLoadingScreen
